import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../Auth/useUser";

function PublicRoute({ children }) {
  const user = useUser();

  // If no user, show the public page (login/register)
  if (!user) {
    return children;
  }

  // If user exists, redirect based on role
  switch (user.result.role) {
    case "user":
    case "admin":
    case "manager":
      return <Navigate to="/" replace />;
    case "waiter":
      return <Navigate to="/receptionorders/org_id" replace />;
    case "caissier":
      return <Navigate to="/caisse" replace />;
    case "serveur":
      return <Navigate to="/caisse" replace />;
    default:
      return children;
  }
}

export default PublicRoute;
